export const STATUS_COLORS = {
  SUCCESS: { stroke: "#005D49", background: "#E6F3F0" },
  ERROR: { stroke: "#CD0202", background: "#FAE6E6" },
  IN_PROGRESS: { stroke: "#0066E0", background: "#EAF2FF" },
  QUEUED: { stroke: "#4b00cc", background: "#4b00cc" },
  DEFAULT: { stroke: "#5C5C5C", background: "#F5F5F5" },
};
